import { render } from "./BackProjectButton.vue?vue&type=template&id=1acb572d"
import script from "./BackProjectButton.vue?vue&type=script&lang=js"
export * from "./BackProjectButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__